import React from 'react';
import Submenu from './Submenu';
import { icons } from '../../icons';
import { Wrapper, SimpleLink } from './styled';
const Links = ({ contrast = false, isMobile = false, links }) => {
    return (React.createElement(Wrapper, { isMobile: isMobile, contrast: contrast }, links.map(({ key, id, link, sublinks = [], src }) => {
        const linkIcon = icons[src || ''];
        const hasSubmenu = sublinks.length > 0;
        if (!hasSubmenu) {
            return (React.createElement(SimpleLink, { key: key, href: link, className: "universal-menu-link", rel: "canonical" },
                React.createElement("span", null, id)));
        }
        return (React.createElement(Submenu, { key: id, id: id, contrast: contrast, links: sublinks, isMobile: isMobile, linkIcon: linkIcon }));
    })));
};
export default Links;
//# sourceMappingURL=Links.js.map